import { useEffect, useState } from "react";
import { Dialog } from "@base-ui/react/dialog";
import { IconSun } from "@tabler/icons-react";
import cafeSvg from "../assets/cafe.svg" with { type: "text" };

const WELCOME_SEEN_KEY = "sunny-coffee-welcome-seen";

export function WelcomeDialog() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const seen = localStorage.getItem(WELCOME_SEEN_KEY);
    if (!seen) {
      setOpen(true);
    }
  }, []);

  const handleOpenChange = (next: boolean) => {
    if (!next) {
      localStorage.setItem(WELCOME_SEEN_KEY, "true");
    }
    setOpen(next);
  };

  return (
    <Dialog.Root open={open} onOpenChange={handleOpenChange}>
      <Dialog.Portal>
        <Dialog.Backdrop className="fixed inset-0 z-50 bg-slate-900/50" />
        <Dialog.Viewport className="fixed inset-0 z-50 flex flex-col items-center justify-start p-4 pt-6 md:justify-center md:pt-4">
          <Dialog.Popup className="w-full max-w-md rounded-2xl border border-slate-200 bg-white p-6 shadow-2xl">
            <div className="flex flex-col items-center gap-4 text-center">
              <div className="flex h-14 w-14 items-center justify-center rounded-full bg-amber-100">
                <IconSun size={32} stroke={2} className="text-amber-600" />
              </div>
              <div>
                <Dialog.Title className="text-3xl font-semibold text-slate-900">
                  Sunny.coffee
                </Dialog.Title>
                <p className="mt-0.5 text-lg font-medium text-slate-500">Find cafes in the sun</p>
              </div>
              <div className="flex flex-col gap-2 rounded-xl bg-slate-50 py-3 px-4">
                <span className="mb-0.5 text-xs font-semibold uppercase tracking-wide text-slate-500">Map Legend</span>
                <div className="flex items-center justify-center gap-6">
                <div className="flex items-center gap-2">
                  <span className="inline-flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-[#fe9a00] text-white" aria-hidden>
                    <span className="h-4 w-4 text-white [&>svg]:h-full [&>svg]:w-full" dangerouslySetInnerHTML={{ __html: cafeSvg }} />
                  </span>
                  <span className="text-sm font-medium text-slate-700">In the sun</span>
                </div>
                <div className="flex items-center gap-2">
                  <span className="inline-flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-[#90a1b9] text-white" aria-hidden>
                    <span className="h-4 w-4 text-white [&>svg]:h-full [&>svg]:w-full" dangerouslySetInnerHTML={{ __html: cafeSvg }} />
                  </span>
                  <span className="text-sm font-medium text-slate-700">In the shadow</span>
                </div>
                </div>
              </div>
              <Dialog.Close
                className="rounded-xl bg-amber-500 px-5 py-2.5 text-sm font-medium text-white transition hover:bg-amber-600"
                aria-label="Start exploring"
              >
                Start Exploring
              </Dialog.Close>
            </div>
          </Dialog.Popup>
        </Dialog.Viewport>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
